module.exports = __webpack_public_path__ + "img/xxhl1.50c8cd30.png";